var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyQuery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 233,
    height: 228.261,
    viewBox: "0 0 233 228.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-835 -375)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 41)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(844.535 335.678)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H5.819V11.639H0Z",
    transform: "translate(0 4.114) rotate(-45)",
    fill: "#e7e7f2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 23.666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H11.639V5.819H0Z",
    transform: "translate(0 8.228) rotate(-45)",
    fill: "#e7e7f2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.657 0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H11.639V5.819H0Z",
    transform: "translate(0 8.228) rotate(-45)",
    fill: "#e7e7f2"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(143.383 142.871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.479,44.208a8.729,8.729,0,1,1,8.729-8.729A8.74,8.74,0,0,1,35.479,44.208Zm0-11.639a2.91,2.91,0,1,0,2.91,2.91A2.914,2.914,0,0,0,35.479,32.569Z",
    transform: "translate(-6.75 -1.75)",
    fill: "#e7e7f2"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(833.035 334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.468,109.245C180.459,75.546,182.8,41,172.19,24.761S129.965-19.483,55.264,29.312s-55.7,101.837-44.028,119.7C65.866,232.642,241.451,168.927,202.468,109.245Z",
    transform: "translate(-0.134 -1.91)",
    fill: "#f8f8f8"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.5,
    cy: 9.5,
    rx: 116.5,
    ry: 9.5,
    transform: "translate(821 543.261)",
    fill: "#f5f5f5",
    opacity: 0.68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2275.885 1282.924)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.332,
    cy: 9.96,
    rx: 42.332,
    ry: 9.96,
    transform: "translate(3185.052 -855.579)",
    fill: "#e7e7f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2624.336-883v19.8s14.584,7.292,43.243,7.292S2709-863.2,2709-863.2V-883s-14.749,6.721-41.421,6.318S2624.336-883,2624.336-883Z",
    transform: "translate(560.716 45.939)",
    fill: "#e7e7f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2624.336-883v19.8s14.584,7.292,43.243,7.292S2709-863.2,2709-863.2V-883s-14.749,6.721-41.421,6.318S2624.336-883,2624.336-883Z",
    transform: "translate(560.716 71.926)",
    fill: "#e7e7f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2624.336-883v19.8s14.584,7.292,43.243,7.292S2709-863.2,2709-863.2V-883s-14.749,6.721-41.421,6.318S2624.336-883,2624.336-883Z",
    transform: "translate(560.716 97.05)",
    fill: "#e7e7f2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyQuery);
export default __webpack_public_path__ + "static/media/empty-query.4dfb8ec40f8a88f7cf288c502cb1faba.svg";
export { ForwardRef as ReactComponent };